/**
 * @file: useBottomSheetComponent.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { BottomSheetContext } from '@gorhom/bottom-sheet/src/contexts/external';
import { useContext } from 'react';
import { Platform } from 'react-native';

export const useBottomSheetComponent = <T, U>(
  NormalComponent: T,
  BottomSheetComponent: U,
): T | U => {
  const isBottomSheet = useContext(BottomSheetContext) != null;
  return Platform.OS === 'web'
    ? NormalComponent
    : isBottomSheet
    ? BottomSheetComponent
    : NormalComponent;
};
